import Image from 'next/image';
import type { ImageIconProps } from './types';

export const IconLine = ({ width, height, className }: ImageIconProps) => {
  return (
    <Image
      src='/images/ui/icons/line.svg'
      width={width}
      height={height}
      alt='LINE'
      className={className}
    />
  );
};
